//-v8.1.2.0.0
window.populateChatPublicConfig = function () {

	window.chat.config.publicUI.admin = {
		ChatClientSidelogging: false,
		MobileDeviceConnectionRetryLimit: 4,
		ConnectionRetryLimit: 10,
		ConnectionRetryIterationCount: 3,
		RequiredFields: []
	}

	console.log('Chat public ui :: admin settings populated');
	/*
	EnableEstimatedWaitTime - This is to make the estimated wait time metric available to show/hide for all queues in the system.  Must be true to use wait time 
	DefaultConfig - these are the global defaults used for any queue not configured individually in the ChatQueues array, which will include the default prechat with no queue passed in (so the drop down is used)
	ChatQueues - customization per queue.  Overrides default values.  Enabled must be true and and QueueId must be valid to have the settings used for the given queue
	*/

	window.chat.config.publicUI.options = {
		EnableEstimatedWaitTime: true, //global switch to show/hide estimated wait time on all prechat forms
		EnableNumberOfAvailableAgents: false, //global switch to show/hide available agents on all prechat forms
		EnableNumberOfIdleAgents: false, //global switch to show/hide idle agents on all prechat forms
		EnableNumberOfChatsWaiting: false, //global switch to show/hide chats waiting on all prechat forms
		EnableBusinessHours: true, //global switch to show/hide business hours on all prechat forms
		EnableQueuingWhenNoAgentsLogin: true, //global switch to enable/disable queuing when there are no agents login
		EnableQueuingInAfterHours: false, //global switch to enable/disable queuing in after hours
		EnablePublicGravatar: true, //global switch to enable/disable gravatar usage for all public users 
		EnableAgentGravatar: true, //global switch to enable/disable gravatar usage for all agents
		UseClickToCommunicate: false, // **BETA**
		DefaultConfig: {
			Enabled: true, //enable/disable this configuration record
			LogoImgPath: '', //Path to the image to be use for branding the chat.  Place your logo(s) here: /CCMWa/Content/images/logo/
			ShowLogo: false, //show/hide an image based on the LogoImgPath
			QueueLabel: 'This is my Label', //a description that will render both on the prechat form and in the browser window title bar
			ShowQueueLabel: true, //show/hide the QueueLabel
			AppendQueueLabelToPageTitle: true, //append the queue label to the html document title tag for the page the chat is hosted in
			FormatPrechatLogoToForm: false, //if a logo is used, it can be formatted to be centered with the form fields on the prechat form and match the width of the fields
			Gradient: true, //true will use the start and end colours below and render gradient background css.  false will render the start colour via css as a solid colour background 
			GradientStartColor: '#FFFFFF', //start colour for the gradient, or colour to render as full solid background
			GradientEndColor: '#385582', //end colour for a gradient background;
			ShowEstimatedWaitTime: true, // show/hide the estimated wait time. Note - must be globally enabled above 
			ShowNumberOfAvailableAgents: false, // show/hide the number of available agents. Note - must be globally enabled above 
			ShowNumberOfIdleAgents: false, // show/hide the number of idle agents. Note - must be globally enabled above 
			ShowNumberOfChatsWaiting: false, // show/hide the number of chats waiting. Note - must be globally enabled above 
			ShowBusinessHours: true, //Show business hours when out of business hours
			AllowQueuingWhenNoAgentsLogin: true, // enable/disable queuing when there are no agents login
			AllowQueuingInAfterHours: false, // enable/disable queuing in after hours
			ShowTopic: true, //show/hide the topic form field on the prechat form
			RequireTopic: true, //require a topic be either static, freeform entered, or selected from the applicable list
			//Topic: null, //null will render freeform field, single entry will render it as a static non editable value, comma separated list will render a drop down
			//Topic: "123:This is my first topic, 456:This is my second topic, 789:This is my quote' topic", 
			DefaultPublicGravatarURL: '', //***encodeURIComponent is used to fully endcode the url as per gravatar spec. https://en.gravatar.com/site/implement/images/***. Default pubic url used to fetch a gravatar image to be used for all agents in all chat sessions.  
			DefaultAgentGravatarURL: '',
			//DefaultPublicGravatarURL: encodeURIComponent('http://s17.postimg.org/rymnivcwr/defaultagent.png'), //***encodeURIComponent is used to fully endcode the url as per gravatar spec. https://en.gravatar.com/site/implement/images/***. Default pubic url used to fetch a gravatar image to be used for all agents in all chat sessions.  
			//DefaultAgentGravatarURL: encodeURIComponent('http://s20.postimg.org/dv4u6kvj1/defaultagentf.jpg'),
			UseDefaultPublicGravatarForAllPublicUsers: false, //will force only the default image to be used for all public users, if false then the default will only show for public users who don't have their own gravatar
			UseDefaultAgentGravatarForAllAgents: false, //will force only the default image to be used for all agents, if false then the default will only show for agents who don't have their own gravatar
			GravatarSize: 32,
			DisableChatRequestIfQueueisNotOpen: true, //Prevent the chat system from accepting chat requests if the queue is not open in acd state.
			OutOfBusinessHoursMsg: 'Sorry but we are currently closed. Please contact us during regular business hours.', //message to show when out of business hours
			UsePrechatArea: true, //Render the prechat form to collect user info to begin a chat
			PrechatDataFromUrl: false, //if UsePrechatArea is false and this is true, then it will validate that a name, email and topic are present in the url to render a chat        
			SupportedProtocols: ['tel',
				'sms'
			], // **BETA** protocols to support for popup menu on phone numbers rendered in chat messages for click to communicate feature
			SupportedEmailProtocols: [
				'mailto'
			], // **BETA** protocols to support for popup menu on email addresses rendered in chat messages for click to communicate feature
			LumaThreshold: 140 //threshold to determine the darkness/brightness of the background colour to determine whether the light or dark icon/font renderings are used.  A lower number will ensure the dark icon/font set is used and a higher number will ensure the light icon/font set is used.
		},
		ChatQueues: [] //add custom configurations for individual chat queues here    (example format in wickedtix sample site...)
	};
	console.log('Chat public ui :: options populated.');
}

window.chatwin = null;

$(document).ready(function () {
	var chatQueueURLInfo = 'https://ccm.universaltelcom.com/ccmwa/chat/f14b4ca9-59a7-43d8-a537-3fd90dde278b';
	$('.chat-button').click(function () {
		var deviceWidth = '320';

		if (typeof window.chatwin != 'undefined' || window.chatwin.closed) {
			var options = 'right=0,bottom=0,width=' + deviceWidth +
				',height=440,toolbar=0,location=0,resizable=0,status=0,scrollbars=0,menubar=0,';
			window.chatwin = window.open(chatQueueURLInfo, 'chatClient', options);
			if (window.chatwin && window.chatwin.open && !window.chatwin.closed) {
				if (typeof window.chatwin.document.chat == 'undefined') {
					console.log('Chat object not yet initialized in the pop up. Initializing now...')
					window.chatwin.document.chat = {};
				}
				window.chatwin.document.chat.config = window.chat.config

				//add the config to the session now so refreshes etc. don't kill it.

				window.chat.config = null;
				console.log('Chat config migrated from calling window to popup.')
			}

			if (window.focus) {
				window.chatwin.focus();
			}
		} else {
			if (window.focus) {
				window.chatwin.focus();
			}
		}
		return false;
	});
});